<template>
    <button
        class="transition-colors w-full flex items-center gap-8 py-8 px-12 group"
        :class="[!disabled ? (danger ? 'text-black hover:text-white hover:bg-semantic-error' : 'text-black hover:text-white hover:bg-primary') : 'text-primary-40', disabled ? 'cursor-not-allowed' : 'cursor-pointer']"
        role="button"
        @click.prevent="handleClick()"
    >
        <svg-icon
            v-if="icon"
            class="w-18 h-18 mr-16"
            :class="!disabled ? 'fill-primary group-hover:fill-white' : 'fill-primary-40'"
            :type="icon"
        />
        <slot><span class="text-nowrap">{{ capitalizeFirst(inputLabel) }}</span></slot>
    </button>
</template>
<script>
import {ucfirst} from "../../../shared/helpers";
import SvgIcon from "./SvgIcon.vue";

export default {
    name: "DropdownItem",
    components: {
        SvgIcon,
    },
    props: {
        inputLabel: String,
        icon: String,
        danger: Boolean,
        disabled: Boolean,
    },
    methods: {
        capitalizeFirst(string) {
            return ucfirst(string);
        },
        handleClick() {
            if (!this.disabled) {
                this.$emit('click');
            }
        }
    }
}
</script>
<style scoped>

</style>